export class CircularArray {
    constructor(size) {
        this.data = new Array(size);
        this.index = 0;
        this.size = size;
    }

    setNext(val) {
        this.data[this.index] = val;
        this.index = (this.index + 1) % this.size;
    }

    avg() {
        var sum = 0;
        for (var i = 0; i < this.size; i++) {
            if (typeof this.data[i] != 'undefined')
                sum += this.data[i];
        }
        return sum / this.size;
    }
}